export const getErrorMessage = (err: any): string => {
  if (!err) return 'خطای ناشناخته'

  if (err?.meta?.errors && typeof err.meta.errors === 'object') {
    const errors = err.meta.errors

    const allErrors: string[] = []

    Object.values(errors).forEach((errorArray: any) => {
      if (Array.isArray(errorArray)) {
        allErrors.push(...errorArray)
      } else if (typeof errorArray === 'string') {
        allErrors.push(errorArray)
      }
    })

    if (allErrors.length > 0) {
      return allErrors.join(' | ')
    }
  }

  if (err?.meta?.message) {
    return err.meta.message
  }

  if (typeof err === 'string') {
    return err
  }

  return 'خطای ناشناخته رخ داده است'
}

export const logError = (err: any, context: string = '') => {
  console.error(`🔴 ${context}:`, err)
  console.log(`🔹 ارور استخراج شده:`, getErrorMessage(err))
}
